import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import OtherSvgArrow from "../../icons/svg/other/OtherSvgArrow";
import { Link, useLocation, useParams } from "react-router-dom";

const SideBarItemList = (props) => {

    const location = useLocation();
    const { title, icon, itemsList } = props;
    const { categoryId } = useParams();
    
    const isActive = () => {
        const item = itemsList?.find(item =>  {
            return (item?.startsWith)
                    ? location.pathname.startsWith(item?.startsWith)
                    : item?.to == location.pathname; 
        });
        return item;
    }

     
    const [show, setShow] = useState(isActive());

     
    return (
         
        <li className={`cursor-pointer pc-item pc-hasmenu ${show ? "pc-trigger" : ""} ${isActive()?'active':''}`}>
        <a className="pc-link" onClick={() => setShow(!show)}>
            <span className="pc-micon">{icon}</span>
            <span className="pc-mtext" data-i18n="Layouts">{title}</span>
            <span className="pc-arrow">
            <OtherSvgArrow/>
            </span>
        </a> 
 
        <AnimatePresence initial={false}>
            {show && (
            <motion.ul
                className="submenu-list"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                style={{ overflow: "hidden" }}>
                    
                    {itemsList && (
                        itemsList.map((item, index)=>{
                            const activeClass = (item?.startsWith)
                                ? location.pathname.startsWith(item?.startsWith) ? 'active' : ''
                                : item?.to == location.pathname ? 'active' : ''; 
                            return (
                                <li className="pc-item" key={`${item.to||item?.href}-${index}`}>
                                    {(item?.to!=='')
                                        ? (<Link className={`pc-link hide-sidebar ${activeClass}`}
                                                to={item.to}>{item.label}</Link>)
                                        : (<a className="pc-link"
                                                href={item?.href||''} 
                                                rel="noopener noreferrer" 
                                                target="_blank">{item.label}</a>)} 
                                </li>
                            )
                        })
                    )}
                    
            </motion.ul>
            )}
        </AnimatePresence>
        </li>
       
    );
};

export default SideBarItemList;
